import { useState, useCallback, useRef } from 'react';

function useChartSet({
  enabledZoom = false,
  enabledMarker = false,
  displayAxisTitle = false,
  displayActionAnnotation = false,
  displayUserAnnotation = false,
  displayDataLabel = false,
  displayMarker = false
} = {}) {
  const chartSetRef = useRef(new Set());
  const [isPlacingMarker, setIsPlacingMarker] = useState(false);
  const register = useCallback((chart) => {
    chartSetRef.current.add(chart);

    return () => {
      chartSetRef.current.delete(chart);
    };
  }, []);
  const placeMarker = useCallback(() => {
    for (let chart of chartSetRef.current) {
      chart.placeMarker();
    }

    setIsPlacingMarker(true);
  }, []);
  const cancelMarker = useCallback(() => {
    setIsPlacingMarker(false);
  }, []);
  const resetMarker = useCallback((_, event) => {
    for (let chart of chartSetRef.current) {
      if (chart !== event?.chart) {
        chart.resetMarker();
      }
    }

    setIsPlacingMarker(false);
  }, []);

  return {
    register,
    placeMarker,
    resetMarker,
    cancelMarker,
    isPlacingMarker,
    config: {
      enabledZoom,
      enabledMarker,
      displayAxisTitle,
      displayActionAnnotation,
      displayUserAnnotation,
      displayDataLabel,
      displayMarker
    }
  };
}

export { useChartSet };
